import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDeleteThemeMutation } from 'src/api/themes';
import { useGlobalModals } from 'src/contexts/global-modals';

export const useDeleteTheme = () => {
  const {
    deleteThemeModal,
    closeDeleteThemeModal,
    openLoadingModal,
    closeLoadingModal,
  } = useGlobalModals();
  const { deleteThemeMutation, isPending } = useDeleteThemeMutation();
  const navigate = useNavigate();

  const open = deleteThemeModal.opened;
  const themeId = deleteThemeModal.themeId;

  const handleConfirm = useCallback(async () => {
    if (!themeId) {
      return;
    }

    openLoadingModal(
      'Deleting theme',
      'Please wait while we delete the theme...'
    );
    closeDeleteThemeModal();

    try {
      await deleteThemeMutation(themeId);
      navigate('/themes');
    } finally {
      closeLoadingModal();
    }
  }, [
    closeDeleteThemeModal,
    closeLoadingModal,
    deleteThemeMutation,
    themeId,
    navigate,
    openLoadingModal,
  ]);

  const handleClose = useCallback(() => {
    closeDeleteThemeModal();
  }, [closeDeleteThemeModal]);

  return {
    handleClose,
    handleConfirm,
    isPending,
    open,
  };
};
